/**
 * Clamps a number between a minimum and maximum value.
 *
 * @param {number} value - The input number to be clamped.
 * @param {number} min - The minimum boundary.
 * @param {number} max - The maximum boundary.
 * @returns {number} - The clamped value within the specified range.
 */
export const clamp = (value, min, max) => {
  if (max === undefined) {
    max = min;
  }

  return Math.min(Math.max(value, min), max);
};
